export default function getSeries(state, pointIds) {
  const seriesById = state.entities.series.byId;
  const seriesToReturn = [];
  for (let i = 0; i < pointIds.length; i += 1) {
    const pointId = pointIds[i];
    // eslint-disable-next-line no-prototype-builtins
    if (seriesById.hasOwnProperty(pointId)) {
      seriesToReturn.push(seriesById[pointId]);
    }
  }
  return seriesToReturn;
}
